export { default } from './ScoredTableItem'
